import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { StripeItem } from "@/types/billing";

interface BillingState {
    products: StripeItem[] | null;
    isLoading: boolean;
    error: string | null;
}

const initialState: BillingState = {
    products: null,
    isLoading: false,
    error: null,
};

const billingSlice = createSlice({
    name: "billing",
    initialState,
    reducers: {
        setProducts: (state, { payload }: PayloadAction<StripeItem[]>) => {
            const sortedProducts = payload.sort((a, b) => a.price - b.price);
            state.products = sortedProducts;
            state.isLoading = false;
            state.error = null;
        },
        setProductsLoading: state => {
            state.isLoading = true;
            state.error = null;
        },
        setProductsError: (state, { payload }: PayloadAction<string>) => {
            state.isLoading = false;
            state.error = payload;
        },
    },
});

export const { setProducts, setProductsLoading, setProductsError } =
    billingSlice.actions;
export const { reducer: billingReducer } = billingSlice;
